import React, { useEffect, useLayoutEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { AiOutlineHome } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import { ReactComponent as ArrowLeft } from "../../images/arrow_left.svg"
import CIForm from './CIForm';
import { DataProvider, useDataContext } from './CIContext';
import CITable from './CITable';
import EditBandScore from './EditBandScore';
import OverallBand from './OverallBand';
import { PageViewType } from './CredibilityIndex.constants';
import { toast } from 'react-toastify';
import { isAnyToastVisible } from './ciUtils';


const ViewCIConfigContent = () => {

    const context = useDataContext();
    const { state:{activePage} } = context!;
    const history = useHistory();

    const handleBack = () => {
        history.push('/settings');
        if (isAnyToastVisible()) {
            toast.dismiss()
        }
    }

    useLayoutEffect(() => {
       const el = document.querySelector('._contentContainer') as HTMLElement | null;
       if (el) {
            el.scrollTop = 0;
            el.scrollLeft = 0;
        }
    }, [activePage]);

    useEffect(() => {
        return () => {
            if (isAnyToastVisible()) {
                toast.dismiss();
            }
        };
    }, [])

    return (

            <div>
                <div className='breadcrumb-section'>
                    <AiOutlineHome />
                    <span className="small"> &gt; <Link to="/settings" className="text-muted">Settings</Link> </span>
                    <span className="small"> &gt; <span className="text-muted">CI Configurations</span> </span>
                    <span className="small"> &gt; <span className="text-muted">Manage CI Configuration</span> </span>
                </div>

                <div className='mt-3 d-flex flex-row align-items-start'>
                    <span className="c-pointer" onClick={handleBack}><ArrowLeft /></span>
                    <div className='d-flex flex-column nav-padding'>
                        <h5>CI Configurations</h5>
                        <p className="text-muted">You can manage CI Configurations here</p>
                    </div>
                </div>
                {activePage === PageViewType.HOME_PAGE && <CIForm />}
                {activePage === PageViewType.TABLE_PAGE && <CITable />}
                {activePage === PageViewType.EDIT_BAND_SCORE_PAGE && <EditBandScore />}
                {activePage === PageViewType.OVERALL_BAND_PAGE && <OverallBand />}
            </div>
    )
}

const ViewCIConfig = () => {
    return <DataProvider>
        <ViewCIConfigContent />
    </DataProvider>
}

export default ViewCIConfig